/** Public section hashes remain valid for shared links to the homepage. */
export const landingSectionTargets: Record<string, string> = {
  "#how-clipping-works": "how-clipping-works",
  "#solutions": "solutions",
  "#blog": "blog",
};

// Keep the matching breakpoint in navigation.css and mobile-navigation.css at 1024px.
export const publicNavigationDesktopQuery = "(min-width: 1024px)";

export type NavigationDestination = {
  label: string;
  href: string;
  kind: "section" | "page";
};

type NavigationLinkConfig = NavigationDestination & {
  /** Fixed semantic suffixes keep copy edits independent from analytics ownership. */
  analyticsSuffix: string;
};

export const homeNavigationLink: NavigationDestination = {
  label: "Evangelist home",
  href: "/",
  kind: "page",
};

export const signInNavigationLink: NavigationDestination = {
  label: "Sign In",
  href: "/admin/signin",
  kind: "page",
};

/** One source for the shared desktop header and mobile drawer on all public pages. */
export const primaryNavigationLinks: readonly NavigationLinkConfig[] = [
  {
    label: "Clipping 101",
    href: "#how-clipping-works",
    kind: "section",
    analyticsSuffix: "how-it-works",
  },
  {
    label: "Evangelist Solutions",
    href: "#solutions",
    kind: "section",
    analyticsSuffix: "solutions",
  },
  {
    label: "Blog",
    href: "/blog",
    kind: "page",
    analyticsSuffix: "blog",
  },
];

export function getPublicNavigationHref(link: NavigationDestination, pathname: string): string {
  return link.kind === "section" && pathname !== "/" ? `/${link.href}` : link.href;
}
